import React from 'react';
import App from './App';
import {createRoot} from 'react-dom/client';
import { Liferay } from './utils/liferay';


let canNavigate = false;
Liferay.on('beforeNavigate', function (event: any) {
  canNavigate = true;
});

export interface LiferayProps {
  properties:{
    urlOpenPay: string | null;
    idMerchantOpenPay: string | null;
    keytMerchantOpenPay: string | null;
    sandboxOpenPay: string | null;
    recaptchaSiteKey: string | null;
  }
}

class WebComponent extends HTMLElement {
  root: any = null;

  connectedCallback() {
    const properties ={
      urlOpenPay: this.getAttribute("PAYMENTS_BASE"),
      idMerchantOpenPay: this.getAttribute("PAYMENTS_OP_MERCHANT"),
      keytMerchantOpenPay: this.getAttribute("PAYMENTS_OP_KEY"),
      sandboxOpenPay: this.getAttribute("SANDBOX_OP"),
      recaptchaSiteKey: this.getAttribute("RECAPTCHA_SITE_KEY"),
    }
    if (!this.root) {
      this.root = createRoot(this);
      this.root.render(<App properties={properties} />);
    }

  }

  disconnectedCallback() {
    if (canNavigate) {
      this.root.unmount();
      delete this.root;
    }
  }
}

const ELEMENT_NAME = 'ce-react-openpay';

if (customElements.get(ELEMENT_NAME)) {
  // eslint-disable-next-line no-console
  console.log(`Skipping registration for <${ELEMENT_NAME}> (already registered)`);
} else {
  customElements.define(ELEMENT_NAME, WebComponent);
}
